import React from "react";
import { useAppState } from "../state/AppStateContext";
import { LANGUAGES, LANGUAGE_SHORT, t } from "../i18n/strings";

export default function LanguageSheet() {
  const { langOpen, toggleLangSheet, lang, setLang } = useAppState();

  if (!langOpen) return null;

  return (
    <div onClick={toggleLangSheet} style={styles.backdrop}>
      <div onClick={(e) => e.stopPropagation()} style={styles.sheet}>
        <div style={styles.handle} />
        <h4 style={styles.title}>{t(lang, "chooseLanguage")}</h4>
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {Object.entries(LANGUAGES).map(([code, name]) => {
            const active = code === lang;
            return (
              <button
                key={code}
                type="button"
                onClick={() => setLang(code)}
                style={{ ...styles.row, background: active ? "var(--color-accent-100)" : "transparent" }}
              >
                <span style={styles.short}>{LANGUAGE_SHORT[code]}</span>
                <span style={{ flex: 1, fontSize: 16 }}>{name}</span>
                {active && (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 12l5 5L20 6" />
                  </svg>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    zIndex: 40,
    background: "rgba(4,12,20,.6)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  sheet: {
    background: "var(--color-surface)",
    borderRadius: "28px 28px 0 0",
    padding: "20px 18px 30px",
    animation: "sheetUp .3s ease",
    maxHeight: "80%",
    overflow: "auto",
  },
  handle: { width: 44, height: 5, borderRadius: 999, background: "var(--color-neutral-600)", margin: "0 auto 16px" },
  title: { fontSize: 21, margin: "0 0 12px" },
  row: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    border: "none",
    cursor: "pointer",
    textAlign: "left",
    padding: "15px 16px",
    borderRadius: 16,
    color: "var(--color-text)",
    width: "100%",
  },
  short: { width: 42, fontFamily: "var(--font-heading)", fontSize: 12, color: "var(--color-accent)" },
};
